import React from 'react';
import ITService from '../images/it.svg';
import { Link } from 'react-router-dom';
import { FaCloud, FaLock, FaMobileAlt, FaDesktop } from 'react-icons/fa';
import SubserviceDetailComponent from '../components/SubserviceDetailComponent';

const services = [
  {
    icon: <FaCloud />,
    title: 'Data Storage & Backup',
    description: 'Protect your data with reliable storage and backup solutions. Ensure data integrity and recovery with our comprehensive services.',
  },
  {
    icon: <FaLock />,
    title: 'Data Analytics & Business Intelligence',
    description: 'Gain insights from your data with advanced analytics and business intelligence. We help you make informed decisions and drive growth.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Database Management',
    description: 'Manage your databases efficiently with our services. We ensure data organization, security, and performance to support your business operations.',
  },
];

const DataManagement = () => {
  return (
    <div className = "relative">
      <img
        className="h-auto w-full object-cover"
        src={ITService}
        alt="IT Services"
      />

      <div>

      <section className='text-left mt-6'>
      <h1 className="text-center my-6 text-2xl font-semibold">Data Management & Analytics</h1>
      </section>
     

      <section>
        <SubserviceDetailComponent services={services}/>
        <div className='mb-6'>
      <h2 className="text-xl font-semibold mb-6 mx-6">Get Started with Expert IT Services</h2>
      <p className="text-md text-black mb-6 px-12 text-left">
      Maximize efficiency, enhance security, and drive growth with our tailored IT Services. Our certified experts provide 24/7 support, proactive monitoring, and strategic IT planning to meet your business needs.
      </p>
      
      <Link to="/contact"
        className="inline-block bg-[#13689b] text-white py-3 px-6 rounded-md text-md font-semibold transition-transform transform hover:scale-105">
      Contact Us
      </Link>
      </div>
      </section>

    </div>

    </div>
  )
}

export default DataManagement
